<template>
  <card>
    <!-- <h4 slot="header" class="card-title">Edit Profile</h4> -->
    <form>
      <div class="row">
        <div class="col-md-4">
          <base-input type="text"
                    label="Your Name"
                    placeholder="Your Name"
                    v-model="user.name"
                    :disabled="true">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Your Email Address"
                    placeholder="Email Address"
                    v-model="user.emailAddress"
                    :disabled="true">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Your Client Name"
                    placeholder="Client Name"
                    v-model="user.client.name"
                    :disabled="true">
          </base-input>
        </div>
      </div>
      <!-- <div class="text-center">
        <button type="submit" class="btn btn-info btn-fill float-right" @click.prevent="updateProfile">
          Update Profile
        </button>
      </div> -->
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    props: {
      user: Object,
    },
    data () {
      return {
        client: {
          company: `Avi's Pizza Co.`,
          emailAddress: 'michael23',
          primaryContactName: 'Mike',
          primaryContactSurname: 'Cools'
        }
      }
    },
    methods: {
      updateProfile () {
        alert('Your data: ' + JSON.stringify(this.user))
      }
    }
  }

</script>
<style>

</style>
